import React, { useMemo } from "react";
import { useApiClient } from "../../../shared/customHooks";
import { useApplicationContext } from "../context/applicationContext";
import { childAttendanceForm } from "../../../shared/formObjects/application/childAttendanceForm";
import BaseApplicationComponent from "../../../shared/baseComponent/baseWrappers/BaseApplicationComponent";

function ChildAttendanceComponent({ disabled, data }: any) {
  const api = useApiClient("ChildAttendance");
  const { id, applicationBase } = useApplicationContext();
  const formContext = useMemo(
    () => ({
      child: applicationBase?.child,
      yearApplied: applicationBase?.childAttendance?.yearApplied,
    }),
    []
  );

  return (
    <BaseApplicationComponent
      formBody={childAttendanceForm}
      headerLabel="Child attendance details"
      editPath="childAttendance"
      apiClient={api}
      disabled={disabled}
      data={data}
      id={id}
      formContext={formContext}
      print={true}
    />
  );
}

export default ChildAttendanceComponent;
